import React from 'react';
import { Helmet } from 'react-helmet';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {Trans, withTranslation} from 'react-i18next';

class PrivacyPolicy extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { props } = this;
        const { domain, i18n: { language } } = props;

        return (
            <>
                <Helmet>
                    <title>{this.props.t('privacyPolicy.metatitle', {domain})}</title>
                    <meta
                        name="description"
                        content={this.props.t('privacyPolicy.metadescription')}
                    />
                    <meta name="keywords" content={this.props.t('privacyPolicy.metakeywords', {domain})} />
                </Helmet>
                <Grid
                    container
                    spacing={2}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={12}>
                        <Box pt={'24px'} pb={'12px'}>
                            <Typography variant="h4" component="h1">
                                {this.props.t('privacyPolicy.heading', {domain})}
                            </Typography>
                        </Box>
                        <Box pl={'2px'}>
                            <Typography variant="body1" component={'div'}>
                                <p><Trans i18nKey="privacyPolicy.body">
                                    We value and respect the privacy of our users, therefore we do not collect or share your personal data with anyone (such as name, surname, gender, date of birth, mail, address, etc.). But we use cookie technology to improve the user experience in order to:
                                </Trans></p>
                                <ul>
                                    <li><Trans i18nKey="privacyPolicy.ul1">to track aggregate information about our visitors, such as: date of visit, user's ip address, name of the browser used, screen size and resolution, device name, referring page, identifier, etc, for this we use Google Analytics.</Trans></li>
                                    <li><Trans i18nKey="privacyPolicy.ul2">to display ads based on your interests (personalized ads), for this use Google Adsense.</Trans></li>
                                </ul>
                                {
                                    language==='en' && <>
                                        <h4>DATA SECURITY</h4>
                                        <p>We take appropriate measures to safeguard your personal information against unauthorized access, disclosure, or use. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee the absolute security of your information.</p>

                                        <h4>CHILDREN IS PRIVACY</h4>
                                        <p>Our Service does not address anyone under the age of 18 (“Children”).</p>

                                        <h4>COMPLIANCE WITH LAWS</h4>
                                        <p>We will disclose your Personal Information where required to do so by law or subpoena.</p>

                                        <h4>CHANGES TO THIS PRIVACY POLICY</h4>
                                        <p>We may update this Privacy Policy from time to time. We encourage you to review this page periodically for any changes. Your continued use of our website following the posting of any updates to this policy will constitute your acceptance of the changes.</p>
                                    </>
                                }
                            </Typography>
                            {/*                                <Typography variant="body1">
                                <Trans i18nKey="about.contact">
                                    По вопросам сотрудничества обращайтесь через контактную
                                    форму:
                                </Trans>{' '}
                                <Link
                                    color="secondary"
                                    target="_blank"
                                    href="https://forms.gle/9cFPn1vp3gFNwYFa9"
                                >
                                    https://forms.gle/9cFPn1vp3gFNwYFa9
                                </Link>
                            </Typography>*/}
                        </Box>
                    </Grid>
                </Grid>
            </>
        );
    }
}

export default withTranslation('translations')(PrivacyPolicy);